import React, {Component} from "react"
import {Container, Header, Loader} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization} from "../utils/localization";
import {setPrevRoute} from "../actions/appHeaderActions";
import {checkIsVerified, EDUCATIONAL_AUTO_ADVANCE_SECONDS, getStepProps, isAIG, isAnsel, isSymetra} from "../utils/common";
import Steps from "./steps/steps";
import Footer from "./footer";
import {CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    return {
        user, initialData, benAdmin,
        name: user.firstName,
        lang: user.lang,
        dependents: user.dependents,
        maritalStatus: user.maritalStatus,
        ...ownProps
    }
};

class WhyUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null
        };
    }

    componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props, initialData.distributionChannel);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
        this.buildSteps();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 0, uiFlow, distributionChannel)});
    }

    render() {
        const {stepProps} = this.state;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const localization = getLocalization(this.props.lang);
        const strings = localization.whyBrella;

        return (
            <React.Fragment>
                <Container className={isSymetra() && 'contentContainer'}>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>
                    <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`} fitted={'horizontally'}>
                        <CustomGrid.Column width={8}>
                            <CustomGrid stackable columns={1}>
                                <CustomGrid.Row>
                                    <CustomGrid.Column textAlign={'left'}>
                                        <Header as='h2'>{strings.title}</Header>
                                        <p className={"neutral700Text small"}>{strings.p1}</p>
                                        <p className={"neutral700Text small"}>{strings.p2}</p>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>

                                <CustomGrid.Row columns={1} centered>
                                    <CustomGrid.Column width={10}>
                                        <S3Image {...IMAGE.WHY_US} />
                                        <table style={{fontSize: '11px', width: '100%'}}>
                                            <thead>
                                            <th align={"center"}>{strings.torn}</th>
                                            <th align={"center"}>{strings.cut}</th>
                                            <th align={"center"}>{strings.dehydration}</th>
                                            <th align={"center"}>{strings.heart}</th>
                                            <th align={"center"}>{strings.appendicitis}</th>
                                            </thead>
                                        </table>
                                        {!isAIG() && <div style={{marginTop: '1em'}}><span className={"smaller neutral700Text"}>*<i>{strings.source}</i></span></div>}
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                            </CustomGrid>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer
                    showTopFooter={true} showCenterData={true}
                    buttonText={localization.next}
                    onClickCallback={() => this.props.history.push(this.props.nextRoute)}
                    autoAdvanceSeconds={EDUCATIONAL_AUTO_ADVANCE_SECONDS}
                />

            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(WhyUs));
